import {useState} from "react";
import {Plus} from "lucide-react";
import {useNavigate} from "react-router-dom";
import {useError} from "@/contexts/ErrorProvider";
import RoundedIcon from "./dashboard/RoundedIcon";
import {apiCreateSimpleProjectList, ProjectCreationResponse} from "@/services/ProjectService";

const SingleServiceItemCreate = () => {
  const navigate = useNavigate();
  const {setIsError} = useError();
  const [isLoading, setIsLoading] = useState(false);
  
  const createSingleService = async () => {
    setIsLoading(true);
    try {
      const response = await apiCreateSimpleProjectList<
        ProjectCreationResponse,
        { projectName: string, mainPackage: string }
      >({projectName: "Single Service", mainPackage: "ai.shreds"});
      
      if (response.data) {
        setIsError('');
        navigate(`/architecture/preview/${response.data.id}`);
      }
    } catch (err: any) {
      setIsError(err.response.data.message);
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    <>
      <div
        onClick={createSingleService}
        className="border-dashed border-2 border-green-600 rounded-lg flex flex-col justify-center items-center gap-2 sm:gap-3 cursor-pointer min-h-[120px] sm:min-h-[150px] p-3 sm:p-4 create_project hover:bg-green-50 transition-colors"
      >
        <RoundedIcon color="green-600" height="h-8 sm:h-11" width="w-8 sm:w-11">
          <Plus className="m-auto text-green-600"/>
        </RoundedIcon>
        <p className="text-green-600 text-center text-sm sm:text-lg font-medium">
          Create Single Service
        </p>
        <p className="text-green-600 text-center text-xs sm:text-sm px-2">
          Create a single service and go directly to code generation.
        </p>
      </div>
      {isLoading && (
        <div
          style={{backgroundColor: "rgba(0, 0, 0, 0.5)"}}
          className="fixed top-0 left-0 w-full h-full flex flex-col items-center justify-center z-50"
        >
          <div className="loader mb-4"></div>
          <p className="text-white text-sm sm:text-lg text-center px-4">
            Creating Single Project, Please Wait...
          </p>
        </div>
      )}
    </>
  );
};

export default SingleServiceItemCreate;
